import { get, getAll } from "@/utilities/querySelector";

function loadYouTubeAPI() {
    if (!window.YT) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
}

// Initialize YouTube players
const players = {};
window.onYouTubeIframeAPIReady = () => {
    getAll('[data-youtube-video]').forEach(iframe => {
        const videoId = iframe.getAttribute('data-video-id');
        players[videoId] = new YT.Player(iframe, {
            events: {
                'onStateChange': (event) => {
                    if (event.data === YT.PlayerState.ENDED) {
                        const playButton = get(`[data-play-video][data-play-video-id="${videoId}"]`);
                        const thumbnail = event.target.getIframe()?.closest('.image-holder')?.querySelector('img');

                        if (playButton) {
                            playButton.style.display = 'flex';
                            playButton.style.opacity = '1';
                        }

                        if (thumbnail) {
                            thumbnail.style.display = 'block';
                            setTimeout(() => {
                                thumbnail.style.opacity = '1';
                            }, 10);
                        }
                    }
                }
            }
        });
    });
};

function initVideoPlayButtons() {
    const videoPlayButtons = getAll('[data-play-video]');
    if (!videoPlayButtons) return;
    loadYouTubeAPI();

    videoPlayButtons.forEach(function(button) {
        const videoId = button.dataset.playVideoId;
        const videoType = button.dataset.videoType;
        const video = get(`[data-video-id="${videoId}"]`);
        const thumbnail = video?.closest('.image-holder')?.querySelector('img');

        if (!video) return;

        button.addEventListener('click', function(e) {
            e.preventDefault();

            button.style.opacity = '0';
            if (thumbnail) thumbnail.style.opacity = '0';

            setTimeout(() => {
                button.style.display = 'none';
                if (thumbnail) thumbnail.style.display = 'none';

                if (videoType === 'file' && video && video.tagName === 'VIDEO') {
                    video.play();
                    video.addEventListener('ended', () => {
                        button.style.display = 'flex';
                        button.style.opacity = '1';
                    }, { once: true });
                } else if (videoType === 'embed' && players[videoId]) {
                    players[videoId].playVideo();
                }
            }, 300);
        });
    });
}

initVideoPlayButtons();

getAll('[data-video-container]').forEach(holder => {
    const observer = new MutationObserver(() => {
        initVideoPlayButtons();
    });
    observer.observe(holder, { childList: true, subtree: true });
});
